export enum AddToCartState {
  Processing = "processing",
  Success = "success",
  Fail = "fail"
}
